import type { EpgChannel, EpgProgram } from '../../types/epg';
import type { PlaylistItem } from '../../types/playlist';

export default abstract class EpgService {
  // @CUSTOMER vd-ott-iq EpgService.fetchPrograms is removed. This class needs to be refactored.
  /**
   * Fetch the schedule data for the given PlaylistItems
   */
  abstract fetchPrograms: (channels: PlaylistItem[], startTime?: number, endTime?: number) => Promise<EpgProgram[]>;

  fetchChannels = async (items: PlaylistItem[], _startTime?: number, _endTime?: number) => {
    return items.map((item) => {
      const catchupHours = item.catchupHours && parseInt(item.catchupHours);

      return {
        id: item.mediaid,
        demo: !!item.scheduleDemo || false,
        title: item.title,
        description: item.description,
        catchupHours: catchupHours ?? 8,
        channelLogoImage: item.channelLogoImage,
        backgroundImage: item.backgroundImage,
        programs: [],
      } as EpgChannel;
    });
  };
}
